import React, { useEffect } from 'react';
import { Tooltip, Flex, Spin, Typography } from '@fuxi/eevee-ui';
import { UploadFile } from 'antd/lib';
import { LoadingOutlined } from '@ant-design/icons';
import { uniqueId } from 'lodash-es';
import MyIcon from '@/components/MyIcon';
import EllipsisMiddle from '@/components/EllipsisMiddle';

import cx from './index.module.css';

const { Link, Text } = Typography;
interface AttachmentListProp {
  attachment: Array<UploadFile>;
  onRemove: (file: UploadFile) => void;
  horizontal?: boolean;
}
const Attachment = ({ file, onRemove, horizontal }) => {
  return (
    <Flex.Item
      className={cx('attachment-item')}
      style={{ justifyContent: !horizontal ? 'space-between' : 'flex-start' }}>
      <div style={{ flex: horizontal ? '1 0 105px' : '1 0 207px' }}>
        <Tooltip title={file.name}>
          <Link
            ellipsis={true}
            href={file.url}
            style={{ maxWidth: horizontal ? '105px' : '207px' }}
            className={cx('attachment-name', file.status === 'error' && 'attachment-name-error')}
            key={`${uniqueId()}-text`}>
            {!horizontal ? (
              <span> {file.name}</span>
            ) : (
              <EllipsisMiddle suffixCount={6} text={file.name}></EllipsisMiddle>
            )}
          </Link>
        </Tooltip>
      </div>
      <Flex alignCenter gap={4}>
        {file.status !== 'done' && file.status !== 'error' && (
          <Flex.Item>
            <div className={cx('attachment-progress')} key={`${uniqueId()}-loading`}>
              <Spin indicator={<LoadingOutlined />} size="small" />
              <span>{file.percent + '%'} </span>
            </div>
          </Flex.Item>
        )}
        <Flex.Item style={{ height: '16px', lineHeight: '16px' }}>
          {(file.status === 'done' || file.status === 'error') && (
            <MyIcon icon="delete-1" className={cx('attachment-icon')} onClick={() => onRemove(file)} size={'16px'} />
          )}
        </Flex.Item>
      </Flex>
    </Flex.Item>
  );
};
const AttachmentList: React.FC<AttachmentListProp> = ({ attachment, onRemove, horizontal = true }) => {
  const [currentList, setCurrentList] = React.useState<Array<UploadFile>>(attachment);
  useEffect(() => {
    setCurrentList(attachment);
  }, [attachment]);
  return (
    <Flex
      gap={horizontal ? 20 : 4}
      className={cx('attachment-list')}
      key={`list-${uniqueId()}`}
      flexDirection={horizontal ? 'row' : 'column'}>
      {currentList?.map(item => {
        return <Attachment file={item} onRemove={onRemove} horizontal={horizontal} key={`${uniqueId()}`} />;
      })}
    </Flex>
  );
};

export default AttachmentList;
